module.exports = __webpack_public_path__ + "img/new_unactive_02.b10aecc3.jpg";